"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaService = void 0;
exports.tranformTpaContact = tranformTpaContact;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const tpa_repository_1 = require("./tpa.repository");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils/masters-validation");
const constants_2 = require("../../../../service-lib/src/lib/constants");
let TpaService = class TpaService {
    constructor(tpaRepository, lookUpValidation, masterValidation) {
        this.tpaRepository = tpaRepository;
        this.lookUpValidation = lookUpValidation;
        this.masterValidation = masterValidation;
    }
    /**
     * Create a new TPA record by delegating its repository.
     */
    async addTpa(createTpaObject, userId) {
        try {
            await this.masterValidation.validateMasterIds(createTpaObject, constants_1.MASTER_DATA);
            await this.lookUpValidation.validateDynamicLookupValues(createTpaObject, constants_1.LOOK_UP_DATA);
            const tpa = await this.tpaRepository.addTpa(createTpaObject, userId);
            (0, response_utils_1.removeMetadataFields)(tpa);
            return tpa;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw error;
        }
    }
    /**
     * Retrieve all TPA recordsby delegating its repository.
     */
    async getTpas(userId, sortBy, page, limit, search, searchBy) {
        try {
            const searchParams = (0, helper_utils_1.mapSearchParams)(search || "");
            const sortParams = (0, helper_utils_1.mapSortParams)(sortBy);
            if (sortParams) {
                const tpaSortOrderSearch = sortParams.find((item) => item.field === constants_2.sortRealtionsMapping.PARENT_TPA_CITY_SORT_KEY);
                if (tpaSortOrderSearch) {
                    tpaSortOrderSearch.field = constants_2.sortRealtionsMapping.PARENT_TPA_CITY_SORT;
                }
                const tpaSortOrderStateSearch = sortParams.find((item) => item.field === constants_2.sortRealtionsMapping.PARENT_TPA_STATE_SORT_KEY);
                if (tpaSortOrderStateSearch) {
                    tpaSortOrderStateSearch.field =
                        constants_2.sortRealtionsMapping.PARENT_TPA_STATE_SORT;
                }
            }
            const [tpaData, count, totalActiveTpa] = await this.tpaRepository.getTpas(userId, searchParams, sortParams, page, limit, searchBy);
            return { data: tpaData, count, totalActiveTpa };
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw error;
        }
    }
    /**
     * Retrieve the TPA record by Id by delegating its repository.
     */
    async getTpaById(tpaId) {
        const tpa = await this.tpaRepository.getTpaById(tpaId);
        if (!tpa) {
            throw new common_1.NotFoundException(messages_1.infoMessages.tpaNotFound);
        }
        (0, response_utils_1.removeMetadataFields)(tpa);
        return tpa;
    }
    /**
     * Update a TPA record by tpaId by delegating its repository.
     */
    async updateTpaById(tpaId, updateTpaObject, userId) {
        try {
            await this.lookUpValidation.validateDynamicLookupValues(updateTpaObject, constants_1.LOOK_UP_DATA);
            const updated = await this.tpaRepository.updateTpaById(tpaId, updateTpaObject, userId);
            if (!updated) {
                throw new common_1.NotFoundException(messages_1.infoMessages.tpaNotFound);
            }
            return updated;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw error;
        }
    }
    /**
     * Delete a TPA record by tpaId by delegating its repository.
     */
    async deleteTpaById(tpaId) {
        try {
            const deleted = await this.tpaRepository.deleteTpaById(tpaId);
            if (!deleted) {
                throw new common_1.NotFoundException(messages_1.infoMessages.tpaNotFound);
            }
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw error;
        }
    }
    /** Returns the active tpa company list data */
    async getCompanyList(page, limit, search, sortBy, sort, userId) {
        try {
            // Check if the user has permission to access the company list
            const tpaCompanies = await this.tpaRepository.CompanyList(page, limit, search, sortBy, sort, userId);
            return tpaCompanies;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error; // Re-throw NotFoundException to be handled by the controller
            }
            throw new Error("Failed to fetch companies");
        }
    }
    /** Returns the active tpa company address and contacts data */
    async getCompanyBasicDetails(id, userId) {
        try {
            const fields = ["id", "tpaName", "displayName"];
            const relations = ["tpaAddresses.address"];
            const whereCondition = {
                id: id,
                createdBy: userId,
            };
            const companyDetails = await this.tpaRepository.getCompanyListData(fields, relations, whereCondition);
            if (!companyDetails) {
                throw new common_1.NotFoundException(messages_1.errorMessages.tpaCompanyNotFound);
            }
            return companyDetails;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error.message);
        }
    }
    /** Fetches TPA contacts by TPA ID. */
    async getTpaContacts(tpaId) {
        try {
            const tpaContacts = await this.tpaRepository.fetchTpaContacts(tpaId);
            if (!tpaContacts || tpaContacts.length === 0) {
                return [];
            }
            // Transform the data to return only necessary fields
            const transformedContacts = tpaContacts.map((contact) => ({
                id: contact.id,
                firstName: contact.firstName,
                lastName: contact.lastName,
                displayName: contact.displayName,
            }));
            return transformedContacts;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error; // Re-throw NotFoundException to be handled by the controller
            }
            throw new common_1.InternalServerErrorException("Failed to fetch TPA contacts: " + error.message);
        }
    }
};
exports.TpaService = TpaService;
exports.TpaService = TpaService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof tpa_repository_1.TpaRepository !== "undefined" && tpa_repository_1.TpaRepository) === "function" ? _a : Object, typeof (_b = typeof lookup_validation_1.LookUpValidationService !== "undefined" && lookup_validation_1.LookUpValidationService) === "function" ? _b : Object, typeof (_c = typeof masters_validation_1.MasterValidationService !== "undefined" && masters_validation_1.MasterValidationService) === "function" ? _c : Object])
], TpaService);
/*
 * Tranform the TPA contact object to remove unnecessary fields.
 */
function tranformTpaContact(contact) {
    delete contact.createdAt;
    delete contact.updatedAt;
    delete contact.createdBy;
    delete contact.updatedBy;
    contact.address?.forEach((address) => {
        delete address.createdBy;
        delete address.updatedBy;
        delete address.createdAt;
        delete address.updatedAt;
    });
    return contact;
}
